import axios from "../axios";

const getProcessingPayIns = async function (accessToken,params = {}) {
    try {
        const response = await axios.get('/bank-transaction/getProcessingPayIns', {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getProcessingPayIns;
